import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { fetchCategories } from './slices/categoriesSlice';
import { fetchSubcategories } from './slices/subcategoriesSlice';
import { fetchContactInfo } from './slices/contactInfoSlice';
import {
  subscribeToCategories,
  subscribeToSubcategories,
  subscribeToContactInfo,
} from '../services/firestoreService';

// Initialize store data on mount
export const StoreProvider = ({ children }) => {
  useEffect(() => {
    // Wait for persist to rehydrate, then load data from Firestore
    const timer = setTimeout(() => {
      console.log('🌍 Loading data from Firebase Firestore...');
      store.dispatch(fetchCategories());
      store.dispatch(fetchSubcategories());
      store.dispatch(fetchContactInfo());
    }, 500);

    // Set up real-time listeners for Firebase Firestore
    // This ensures data syncs globally across ALL devices instantly!
    let unsubscribeCategories = null;
    let unsubscribeSubcategories = null;
    let unsubscribeContactInfo = null;

    try {
      // Real-time sync for categories
      unsubscribeCategories = subscribeToCategories((categories) => {
        console.log('✅ Categories updated from Firestore!', categories);
        store.dispatch({ type: 'categories/setCategories', payload: categories });
      });

      // Real-time sync for subcategories
      unsubscribeSubcategories = subscribeToSubcategories((subcategories) => {
        console.log('✅ Subcategories updated from Firestore!', subcategories);
        store.dispatch({ type: 'subcategories/setSubcategories', payload: subcategories });
      });

      // Real-time sync for contact info
      unsubscribeContactInfo = subscribeToContactInfo((contactInfo) => {
        if (contactInfo) {
          console.log('✅ Contact info updated from Firestore!');
          store.dispatch({ type: 'contactInfo/setContactInfo', payload: contactInfo });
        }
      });
    } catch (error) {
      console.log('Firestore listeners not available:', error.message);
    }

    // Periodic refresh every 30 seconds (backup)
    const syncInterval = setInterval(() => {
      store.dispatch(fetchCategories());
      store.dispatch(fetchSubcategories());
      store.dispatch(fetchContactInfo());
    }, 30000);

    return () => {
      clearTimeout(timer);
      clearInterval(syncInterval);
      if (unsubscribeCategories) unsubscribeCategories();
      if (unsubscribeSubcategories) unsubscribeSubcategories();
      if (unsubscribeContactInfo) unsubscribeContactInfo();
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
};

// Export store and hooks for direct access if needed
export { store } from './store';
export { useDispatch, useSelector } from 'react-redux';

